var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimatePresence, motion } from "framer";
import { useCallback, useRef, useState } from "react";
import styled from "styled-components";
import { BaseButton, Title } from "../../designSystem";
import colors from "../../designSystem/colors";
import sizes from "../../designSystem/sizes";
import theme from "../../designSystem/theme";
import { useBoundingclientrect } from "../../hooks/useBoundingclientrect";
import useOutsideAlerter from "../../hooks/useOutsideAlerter";
import useScreenSize from "../../hooks/useScreenSize";
import { capitalize } from "../../utils/text";
import ButtonArrow from "./ButtonArrow";
var Filter = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var FilterButton = styled(BaseButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  padding: ", ";\n  background-color: ", ";\n\n  &:hover {\n    background-color: ", ";\n\n    span {\n      color: ", ";\n    }\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  padding: ", ";\n  background-color: ", ";\n\n  &:hover {\n    background-color: ", ";\n\n    span {\n      color: ", ";\n    }\n  }\n"])), function (props) {
    return props.config.paddingVertical + "px " + props.config.paddingHorizontal + "px";
}, function (props) {
    return props.active ? props.config.activeBackground : props.config.background;
}, function (props) { return props.config.activeBackground; }, colors.primaryText);
var FilterButtonText = styled(Title)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 14px;\n  color: ", ";\n  text-transform: uppercase;\n"], ["\n  font-size: 14px;\n  color: ", ";\n  text-transform: uppercase;\n"])), function (props) { return props.config.color; });
var FilterDropdownMenu = styled(motion.div)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    return props.isOpen
        ? "\n          position: absolute;\n          z-index: 2000;\n          " + (function () {
            switch (props.config.horizontalOrientation) {
                case "left":
                    return "left: 0px;";
                case "right":
                default:
                    return "right: 0px;";
            }
        })() + "\n          " + (function () {
            switch (props.verticalOrientation) {
                case "top":
                    return "bottom: 48px;";
                case "bottom":
                default:
                    return "top: calc(21px + " + props.buttonPaddingVertical * 2 + "px + " + props.config.topBuffer + "px);";
            }
        })() + "\n          width: fit-content;\n          background-color: " + colors.backgroundDarker + ";\n          border: " + theme.border.width + " " + theme.border.style + " " + colors.border + ";\n          border-radius: " + theme.border.radius + ";\n        "
        : "\n          display: none;\n        ";
});
var MenuItem = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: 8px 16px;\n  padding-right: 66px;\n  opacity: 1;\n  display: flex;\n  align-items: center;\n\n  &:first-child {\n    padding-top: 16px;\n  }\n\n  &:last-child {\n    padding-bottom: 16px;\n  }\n\n  &:hover {\n    span {\n      color: ", ";\n    }\n  }\n"], ["\n  padding: 8px 16px;\n  padding-right: 66px;\n  opacity: 1;\n  display: flex;\n  align-items: center;\n\n  &:first-child {\n    padding-top: 16px;\n  }\n\n  &:last-child {\n    padding-bottom: 16px;\n  }\n\n  &:hover {\n    span {\n      color: ", ";\n    }\n  }\n"])), colors.primaryText);
var MenuItemText = styled(Title)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", "A3;\n  white-space: nowrap;\n  font-size: 14px;\n  line-height: 20px;\n"], ["\n  color: ", "A3;\n  white-space: nowrap;\n  font-size: 14px;\n  line-height: 20px;\n"])), colors.primaryText);
var FilterDropdown = function (_a) {
    var options = _a.options, value = _a.value, onSelect = _a.onSelect, _b = _a.buttonConfig, buttonConfig = _b === void 0 ? {
        background: colors.backgroundDarker,
        activeBackground: colors.backgroundDarker,
        paddingHorizontal: 12,
        paddingVertical: 8,
        color: colors.primaryText + "A3",
    } : _b, _c = _a.dropdownMenuConfig, dropdownMenuConfig = _c === void 0 ? {
        topBuffer: 8,
    } : _c, props = __rest(_a, ["options", "value", "onSelect", "buttonConfig", "dropdownMenuConfig"]);
    var ref = useRef(null);
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useScreenSize(), height = _e.height, width = _e.width;
    var dropdownBoundingRect = useBoundingclientrect(ref);
    useOutsideAlerter(ref, function () {
        setOpen(false);
    });
    var renderMenuItem = useCallback(function (title, onClick) { return (_jsx(MenuItem, __assign({ onClick: onClick, role: "button" }, { children: _jsx(MenuItemText, { children: title }, void 0) }), title)); }, []);
    var getVerticalOrientation = useCallback(function () {
        /**
         * Height of dropdown: 48px
         * Height of each option: 36px
         * Total dropdown margin: 16px
         */
        if (dropdownBoundingRect &&
            dropdownBoundingRect.top +
                48 +
                options.length * 36 +
                16 +
                (width > sizes.lg
                    ? theme.footer.desktop.height
                    : theme.footer.mobile.height) >
                height) {
            return "top";
        }
        return "bottom";
    }, [width, height, dropdownBoundingRect, options]);
    return (_jsxs(Filter, __assign({}, props, { ref: ref }, { children: [_jsx(FilterButton, __assign({ role: "button", active: open, onClick: function () {
                    setOpen(function (open) { return !open; });
                }, config: buttonConfig }, { children: _jsxs(FilterButtonText, __assign({ config: buttonConfig }, { children: [value, " ", _jsx(ButtonArrow, { isOpen: open }, void 0)] }), void 0) }), void 0), _jsx(AnimatePresence, { children: _jsx(FilterDropdownMenu, __assign({ isOpen: open, verticalOrientation: getVerticalOrientation(), buttonPaddingVertical: buttonConfig.paddingVertical, config: dropdownMenuConfig, initial: {
                        opacity: 0,
                        y: 20,
                    }, animate: {
                        opacity: 1,
                        y: 0,
                    }, exit: {
                        opacity: 0,
                        y: 20,
                    }, transition: {
                        type: "keyframes",
                        duration: 0.2,
                    } }, { children: options.map(function (filterOption) {
                        return typeof filterOption === "string"
                            ? renderMenuItem(capitalize(filterOption), function () {
                                onSelect(filterOption);
                                setOpen(false);
                            })
                            : renderMenuItem(capitalize(filterOption.display), function () {
                                onSelect(filterOption.value);
                                setOpen(false);
                            });
                    }) }), open.toString()) }, void 0)] }), void 0));
};
export default FilterDropdown;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=FilterDropdown.js.map